import React, { useEffect, useRef } from 'react';
import Image from 'next/image';
import {
  Swiper,
  SwiperSlide,
  type SwiperProps,
  type SwiperRef,
} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/zoom';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Scrollbar, Zoom } from 'swiper/modules';
import classNames from 'classnames';

import { type ImageType } from '@/common/types/image.type';

export interface SwiperImageProps extends SwiperProps {
  activeIndex: number;
  images: ImageType[];
}

export default function GalleryCarousel({
  initialSlide = 0,
  activeIndex,
  images,
  ...rest
}: SwiperImageProps) {
  const swiperRef = useRef<SwiperRef>(null);

  useEffect(() => {
    swiperRef.current?.swiper.slideTo(activeIndex);
  }, [activeIndex]);

  return (
    <Swiper
      zoom={true}
      scrollbar={{ hide: true }}
      modules={[Zoom, Scrollbar]}
      className={classNames('mySwiper !h-[372px] rounded-md bg-silver-100')}
      ref={swiperRef}
      initialSlide={initialSlide}
      {...rest}
    >
      {images
        ? images?.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="relative h-[372px] w-full">
                <Image
                  src={image.url || ''}
                  alt={image.name || ''}
                  fill
                  objectFit={'contain'}
                  priority={index === 0}
                  loading={index === 0 ? undefined : 'lazy'}
                  sizes="(max-width: 768px) 100vw, 372px"
                />
              </div>
            </SwiperSlide>
          ))
        : []}
    </Swiper>
  );
}
